module.exports = __webpack_public_path__ + "img/ico-copy.dff6238c.svg";